<template>
  <h3>{{ title }}</h3>
  <Bar :chart-options="options" :chart-data="data" :chart-id="id" />
</template>

<script>
import ChartDataLabels from "chartjs-plugin-datalabels";
import annotationPlugin from "chartjs-plugin-annotation";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ChartDataLabels,
  annotationPlugin
);

import { Bar } from "vue-chartjs";

export default {
  name: "HnBar",
  components: { Bar },
  props: ['data', 'options', 'id', 'title']
}
</script>
